export default __webpack_public_path__ + "static/media/record-overlay.96e116a7.svg";